<template>
    <v-card class="message elevation-0 pa-0" max-width="48rem">
        <v-card-text class="message">
            <v-row no-gutters class="text-caption">
                <v-col cols="12">
                    {{ $t('Registration_is_complete.') }}
                </v-col>
                <v-col cols="12" class="mb-5">
                    {{
                        $t(
                            'If_you_want_to_use_multifactor_authentication,_please_log_in_using_the_password_and_the_one-time_password_displayed_in_Google_Authenticator.'
                        )
                    }}
                </v-col>
            </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
            <v-spacer />
            <button-app-control ref="submit-btn" :label="$t('Return')" text @click="returnQRcodeDescription()" />
            <button-app-control ref="submit-btn" :label="$t('Close')" @click="closeDialog()" />
        </v-card-actions>
    </v-card>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import { ButtonAppControl } from '../../atoms';

@Component({
    name: 'CardRegisterCompletion',
    components: {
        ButtonAppControl,
    },
})
export default class CardRegisterCompletion extends Vue {
    /**
     * methods
     */
    closeDialog(): void {
        this.$emit('closeDialog');
    }
    returnQRcodeDescription(): void {
        this.$emit('returnQrcodeDescription');
    }
}
</script>

<style lang="scss">
.message {
    word-break: break-all;
}
</style>
